import { FC } from 'react'
import Image from 'next/image'

import { Breadcrumbs } from './BreadCrumbs'
// Utils
import { findWord } from '@utils'
import { getCoverImages, getTitleAndDescription } from './util/helper'
import s from './LandingCover.module.scss'
import Trustpilot from '@/components/trustpilot'

const badges = [
  {
    id: 1,
    image: '/landing/responsible_breeder.svg',
    text: 'Responsible Breeders',
  },
  {
    id: 2,
    image: '/landing/concierge.svg',
    text: 'Excellent Customer Service',
  },
  {
    id: 3,
    image: '/landing/travel.svg',
    text: 'Nationwide Travel',
  },
]

const Badge = ({ image, text }) => {
  return (
    <div className={s.badge}>
      <Image height={60} width={60} src={image} alt={text} />
      <h3>{text}</h3>
    </div>
  )
}

const ContentContainer = ({
  title,
  description,
  coverImage,
  mobileCoverImage,
  landingType,
  variables,
  breed,
  category,
  categoryName,
  city,
}) => {
  const altImg =
    landingType === 'breedState'
      ? `Dogs in ${variables?.stateName}`
      : breed?.name
        ? `${findWord(breed?.name)} dog`
        : category

  const mobileImgProps = {
    width: 414,
    height: 190,
    quality: 90,
    src: mobileCoverImage,
    alt: altImg,
    priority: true,
  }

  const desktopImgProps = {
    width: 391,
    height: 370,
    quality: 90,
    src: coverImage,
    alt: altImg,
    priority: true,
  }

  return (
    <div className={s.container}>
      <div className={s.breadcrumbs}>
        <Breadcrumbs
          landingType={landingType}
          variables={variables}
          category={categoryName}
          breed={breed}
          city={city}
        />
      </div>

      <div className={s.cardsContainer}>
        <div className={s.breedCardSummary}>
          <h1>{title}</h1>
          <p className={s.description}>{description}</p>
          <div className={s.badgeContainer}>
            {badges?.map((badge) => (
              <Badge key={badge.id} image={badge.image} text={badge.text} />
            ))}
          </div>
          <div className={s.trustpilot}>
            <Trustpilot />
          </div>
        </div>

        {/* Mobile image */}
        <div className={s.mobileCoverImg}>
          <Image {...mobileImgProps} alt="mobile landing cover image" />
        </div>
        {/* Desktop Image */}
        <div className={s.desktopImageHolder}>
          <Image {...desktopImgProps} alt="desktop landing cover" />
        </div>
      </div>
    </div>
  )
}

interface LandingCoverProps {
  breed?: any
  category?: string
  categoryName?: string
  state?: string
  landingType?: string
  variables?: any
  city?: string
}

const LandingCover: FC<LandingCoverProps> = ({
  breed,
  category,
  categoryName,
  state,
  landingType,
  variables,
  city,
}) => {
  const { coverImage, mobileCoverImage } = getCoverImages(
    category,
    breed,
    state
  )
  const { title, description } = getTitleAndDescription(
    landingType,
    breed,
    categoryName,
    variables,
    city
  )

  return (
    <div className={s.landingCoverContainer}>
      <div className={s.backgroundCover} />
      <ContentContainer
        title={title}
        description={description}
        coverImage={coverImage}
        mobileCoverImage={mobileCoverImage}
        landingType={landingType}
        variables={variables}
        breed={breed}
        category={category}
        categoryName={categoryName}
        city={city}
      />
    </div>
  )
}

export default LandingCover
